import { AfterViewInit, ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { IMenuItem } from 'src/app/core/interfaces/menu-item';
import { AuthService } from 'src/app/core/services/auth.service';
import { BreadCrumbService } from 'src/app/core/services/bread-crumb.service';
import { SecureStorageService } from 'src/app/core/services/secure-storage.service';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  standalone: false
})
export class SidebarComponent implements AfterViewInit { 

  @Input() menus : any;

  home = { icon: 'pi pi-home', routerLink: '/' };

  renderMenu: any[] = [];
  cloneMenu: any[] = [];
  MenuOriginal: any[] = [];
  breadCrumb: any = []

  flagMenuActive: boolean = false;
  menuLoaded!: boolean;
  isVisibleImage: boolean = true;
  isVisible: boolean = false;
  browserRefresh: boolean = false;
  flagSidebar: boolean = false
  flagMode:boolean = false
  isBreadcrumbFixed: boolean = false;
  showScreenInit: boolean = true;

  textMode:string = "Oscuro"
  iconMode:string = "bx-moon"
  name: any;

  parametros : any = {};

  constructor(
    private themeService: ThemeService,
    private routerparams: Router, 
    private authService: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private breadCrumbService: BreadCrumbService,
    private secureStorageService: SecureStorageService
  ){
    
    const body = document.querySelector("body"),
          modeSwitch = body?.querySelector(".toggle-switch");

          modeSwitch?.addEventListener("click", ()=>{
            body?.classList.toggle("dark")
          })
          
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      if(propName === 'menus'){
        this.initialControlBanner();
        this.groupMenu(changes[propName].currentValue);

        const data = JSON.parse(this.secureStorageService.getData('parametros') || "false");

        if(data){
          this.parametros = data;

          document.documentElement.style.setProperty('--primary-color-mnt', this.parametros.color_tema_primario);
          document.documentElement.style.setProperty('--p-primary-color', this.parametros.color_tema_primario);
          document.documentElement.style.setProperty('--p-primary-500', this.parametros.color_tema_primario);
          document.documentElement.style.setProperty('--p-primary-600', this.parametros.color_tema_primario);
          document.documentElement.style.setProperty('--secundary-color', this.parametros.color_tema_secundiario);
          document.title = data.nombre; 
          this.changeFavicon(data.logo_primario);
        }
        
      }
    }
  }

  private changeFavicon(iconUrl: string): void {
    const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = iconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  ngOnInit(): void {
    const user = this.authService.getUserDetails();
    this.name = user?.name ?? ""; 
  }

  ngAfterViewInit() {
    this.breadCrumbService.getBreadCrumb.subscribe((NewBreadCrumb) => {
      this.breadCrumb = NewBreadCrumb;
      this.changeDetectorRef.detectChanges();
    });
  }

  initialControlBanner(){
    this.showScreenInit = this.routerparams.url === '/' ? true : false;
    this.routerparams.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showScreenInit = event.url === '/' ? true : false;
      }
    });
  }


  toggleBreadcrumbFixed() {
    this.isBreadcrumbFixed = !this.isBreadcrumbFixed;
  }

  customBreadCrumbLink(event: any){
    if(event.item.routerLink === "/"){
      this.breadCrumbService.setBreadCrumb([])
    }
  }


  filterMenu(menuData: any, searchText: any) {

    const childFiltered = menuData.filter((parent: any) => {
        const child = parent.children.find((child: any) => child.text.toLowerCase().includes(searchText.toLowerCase()));
        return child !== undefined;
    });

    const parentFiltered = menuData.filter((parent: any) => {
        return parent.text.toLowerCase().includes(searchText.toLowerCase());
    });

    if (childFiltered.length > 0) {
        const parentsWithFilteredChild = childFiltered.map((parent: any) => {
            const filteredChild = parent.children.find((child: any) => child.text.toLowerCase().includes(searchText.toLowerCase()));
            return {
                ...parent,
                children: [filteredChild]
            };
        });
        return parentsWithFilteredChild;
    } else if (parentFiltered.length > 0) {
        const parentWithAllChildren = parentFiltered.map((parent: any) => {
            return {
                ...parent,
                children: parent.children
            };
        });
        return parentWithAllChildren;
    }

    return [];
  }


  modeSwitch(){

    this.flagMode = !this.flagMode;

    const body = document.querySelector("body")
    

    if(this.flagMode){
      this.textMode = "Claro"
      this.iconMode = "bx-sun"
      this.themeService.switchTheme("dark")
      body?.classList.remove("light");
      body?.classList.toggle("dark")

    }else{
      this.textMode = "Oscuro"
      this.iconMode = "bx-moon"
      this.themeService.switchTheme("light")
      body?.classList.remove("dark");
      body?.classList.toggle("light")
    }
  }

  toggle(){

    if(!this.flagSidebar) this.contractAll(this.cloneMenu);

    const sidebar = document.querySelector(".sidebar")
    sidebar?.classList.toggle("close")
    this.flagSidebar = !this.flagSidebar
    
  }

  getText(target: any){

    if (target.value ==""){
      this.cloneMenu = this.renderMenu
    }else{
      const dataFiltrada = this.filterMenu(this.renderMenu, target.value)
      this.cloneMenu = dataFiltrada
      this.expandtAll(this.cloneMenu);
    }
    
  }

  toggleSearch(opcion: string){
    const sidebar = document.querySelector(".sidebar")
    if (sidebar?.classList.contains("close") && opcion == "buscar") {
      sidebar?.classList.toggle("close")
      this.flagSidebar = !this.flagSidebar
    }
    
  }

  onIndex(){
    this.breadCrumbService.setBreadCrumb([])
    this.routerparams.navigate(['/']);
  }

  groupMenu(menu: IMenuItem[]): void {
    this.renderMenu = [];
    while (menu.length > 0) {
      menu.forEach((menuItem: IMenuItem): void => {
        menuItem.text = this.capitalizeSentence(menuItem.text);
        menuItem.children = [];

        if (!menuItem.menuFatherId) {
          const index: number = menu.indexOf(menuItem);
          if (index !== -1) {
            menu.splice(index, 1);
          }
          this.renderMenu.push(menuItem);
          this.renderMenu.sort(this.compareOrders);

        } else {
          const father: string = menuItem.menuFatherId;

          this.searchFather(this.renderMenu, father, menuItem, menu);
        }
      });
    }
    this.menuLoaded = true;
    this.cloneMenu = JSON.parse(JSON.stringify(this.renderMenu));
    this.MenuOriginal = JSON.parse(JSON.stringify(this.renderMenu));
  }

  searchFather(menuArray: IMenuItem[], father:any, menuItem: IMenuItem, menu:any): void {
    menuArray.forEach((menuPainted: IMenuItem): void => {
      if (menuPainted.id === father) {
        menuPainted.children.push(menuItem);

        menuPainted.children.sort(this.compareOrders);

        const index: number = menu.indexOf(menuItem);
        if (index !== -1) {
          menu.splice(index, 1);
        }
      } else {
        this.searchFather(menuPainted.children, father, menuItem, menu);
      }
    });
  }

  capitalizeSentence(sentence: string): string {
    const words: string[] = sentence.split(" ");
    const capitalizedWords: string[] = words.map((word: string) => {
      word = word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(" ");
  }

  compareOrders(p1:any, p2:any): number {
    if (p1.order > p2.order) {
      return 1;
    } else if (p1.order < p2.order) {
      return -1;
    } else {
      return 0;
    }
  }

  contractAll(menuItems: any[]): void {
    menuItems.forEach(menuItem => {
      menuItem.isCollapsed = false;
      if (menuItem.children && menuItem.children.length > 0) {
        this.contractAll(menuItem.children);
      }
    });
  }

  expandtAll(menuItems: any[]): void {
    menuItems.forEach(menuItem => {
      menuItem.isCollapsed = true;
      if (menuItem.children && menuItem.children.length > 0) {
        this.contractAll(menuItem.children);
      }
    });
  }

  getClick(event:boolean){
    
    if(event){

      if(!this.flagSidebar) this.contractAll(this.cloneMenu)
  
      const sidebar = document.querySelector(".sidebar")
      sidebar?.classList.toggle("close")
      this.flagSidebar = !this.flagSidebar
    }

  }

  getOnAccionMiniNav(event:boolean){

    if(event){
      if(this.flagSidebar){
        this.toggle()
      }
    }

  }

  logout(){
    if(this.flagMode) this.lightModeReset();
    this.authService.microsoftLogout();
  }

  lightModeReset(){
    const body = document.querySelector("body")
    body?.classList.toggle("dark")
    this.themeService.switchTheme("light")
    this.flagMode = true;
  }

}
